import React, { useState, useId, useEffect } from 'react';
import { DateRange } from '@iroomit/react-date-range';
import { format, isValid, isBefore } from 'date-fns';

function DateRangeFilter({ startField, endField, onDateRangeChange, resetDates }) {
  const KEY = 'selection';
  const [range, setRange] = useState({
    startDate: null,
    endDate: new Date(''),
    key: KEY,
  });

  useEffect(() => {
    if (resetDates) {
      resetDateRange();
    }
  }, [resetDates]);

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(false);
  const [isStart, setIsStart] = useState(true);
  const dialogId = useId();

  // The DateRange component doesn't allow for empty inital date range
  // so this is a hacky solution using an invalid end date.
  // https://github.com/hypeserver/react-date-range/issues/330
  function handledDateRangeChange({ selection }) {
    // On inital selection, the start date is null.
    let startDate = selection.startDate;
    let endDate = selection.endDate;
    if (!range.startDate || !isValid(range.startDate)) {
      setRange({
        startDate: endDate,
        endDate,
        key: KEY,
      });
      setIsStart(false);
      return;
    }
    // console.log('Selected start: %s \n Selected End: %s', selection.startDate.toDateString(), selection.endDate.toDateString());
    if (isStart) {
      // console.log('Selecting start date');
      startDate = selection.endDate;
      endDate = selection.endDate;
      if (isBefore(selection.startDate, range.startDate)) {
        startDate = selection.startDate;
        endDate = selection.startDate;
      }
      setIsStart(false);
    }
    else {
      // console.log('Selecting end date');
      if (isBefore(selection.endDate, range.startDate)) {
        startDate = selection.endDate;
        endDate = range.startDate;
      } else {
        startDate = range.startDate;
        endDate = selection.endDate;
      }
      setIsStart(true);
    }
    setSelected(true);
    setRange({
      startDate,
      endDate,
      key: KEY,
    });
    onDateRangeChange({
      startDate,
      endDate,
      startField,
      endField
    });
  }

  function resetDateRange() {
    setSelected(false);
    setIsStart(true);
    setRange({
      startDate: null,
      endDate: new Date(''),
      key: KEY,
    });
    onDateRangeChange({
      startDate: null,
      endDate: null,
      startField,
      endField
    });
  }

  function handleClick(event) {
    setOpen(!open);
  }
  return(
    <div className="react-date-range surface--light-lightest-cream">
      <div className={`react-date-range-wrapper ${selected ? 'range-selected' : ''}`} aria-label="Select date range" aria-controls={dialogId} onClick={handleClick}>
        <div className='range start'>
          <h4> Start </h4>
          { selected && <span> { format(range.startDate, 'MM/dd/yy') } </span> }
        </div>
        <div className='range end'>
          <div>
            <h4> End </h4>
            { selected && <span> { format(range.endDate, 'MM/dd/yy') } </span> }
          </div>
          <span>
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="44" height="44" fill={`${open ? '#342649' : '#F7EDE4'}`}/>
              <path d="M18.5714 13C19.2036 13 19.7143 13.5027 19.7143 14.125V15.25H24.2857V14.125C24.2857 13.5027 24.7964 13 25.4286 13C26.0607 13 26.5714 13.5027 26.5714 14.125V15.25H28.2857C29.2321 15.25 30 16.0059 30 16.9375V18.625H14V16.9375C14 16.0059 14.7679 15.25 15.7143 15.25H17.4286V14.125C17.4286 13.5027 17.9393 13 18.5714 13ZM14 19.75H30V29.3125C30 30.2441 29.2321 31 28.2857 31H15.7143C14.7679 31 14 30.2441 14 29.3125V19.75ZM16.2857 22.5625V23.6875C16.2857 23.9969 16.5429 24.25 16.8571 24.25H18C18.3143 24.25 18.5714 23.9969 18.5714 23.6875V22.5625C18.5714 22.2531 18.3143 22 18 22H16.8571C16.5429 22 16.2857 22.2531 16.2857 22.5625ZM20.8571 22.5625V23.6875C20.8571 23.9969 21.1143 24.25 21.4286 24.25H22.5714C22.8857 24.25 23.1429 23.9969 23.1429 23.6875V22.5625C23.1429 22.2531 22.8857 22 22.5714 22H21.4286C21.1143 22 20.8571 22.2531 20.8571 22.5625ZM26 22C25.6857 22 25.4286 22.2531 25.4286 22.5625V23.6875C25.4286 23.9969 25.6857 24.25 26 24.25H27.1429C27.4571 24.25 27.7143 23.9969 27.7143 23.6875V22.5625C27.7143 22.2531 27.4571 22 27.1429 22H26ZM16.2857 27.0625V28.1875C16.2857 28.4969 16.5429 28.75 16.8571 28.75H18C18.3143 28.75 18.5714 28.4969 18.5714 28.1875V27.0625C18.5714 26.7531 18.3143 26.5 18 26.5H16.8571C16.5429 26.5 16.2857 26.7531 16.2857 27.0625ZM21.4286 26.5C21.1143 26.5 20.8571 26.7531 20.8571 27.0625V28.1875C20.8571 28.4969 21.1143 28.75 21.4286 28.75H22.5714C22.8857 28.75 23.1429 28.4969 23.1429 28.1875V27.0625C23.1429 26.7531 22.8857 26.5 22.5714 26.5H21.4286ZM25.4286 27.0625V28.1875C25.4286 28.4969 25.6857 28.75 26 28.75H27.1429C27.4571 28.75 27.7143 28.4969 27.7143 28.1875V27.0625C27.7143 26.7531 27.4571 26.5 27.1429 26.5H26C25.6857 26.5 25.4286 26.7531 25.4286 27.0625Z" fill={`${!open ? '#342649' : '#F7EDE4'}`}/>
            </svg>
          </span>
        </div>
      </div>
      <div id={dialogId} aria-hidden={!open} className={`dialog-content ${open ? 'd-block' : 'd-none'}`}>
        {/* DO NOT change the moveRangeOnFirstSelection or retainEndDateOnFirstSelection */}
        <DateRange
          showDateDisplay={false}
          showMonthArrow={false}
          dragSelectionEnabled={false}
          editableDateInputs={false}
          moveRangeOnFirstSelection={false}
          retainEndDateOnFirstSelection={false}
          onChange={handledDateRangeChange}
          ranges={[range]}
        />
        <div tabIndex="-1" aria-label="Clear Selected Date Range" className="link-underline" onClick={resetDateRange}> Reset </div>
      </div>
    </div>
  );
}

export default DateRangeFilter;
